module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAG1BMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDP/rDP/rDO3qpHeAAAACHRSTlMAQAAQv5/PrypZZKMAAAC/SURBVHhe7dQxjsJADAXQzxVS0RLgAhR7AKrUc4Vttt8TUIB8bMpI85AiTYnyy5H1CtvjmD17cpjmPukfzstzu+inqiH10F8VVISkIiQVIakISUVIKkJSEZKKkFSEpCIkFSGpCElFSCpCUhFaKaSlyLOXrmWqddKxTD1Gii5l6t5JdqDqdbMF5PdzM4Uci5ADBlolKCCXTsj1FfIjCK2S1P/Y55RqYwdDqo0dMak2dlihgAaP/XyaNovM9xft0ht3UtWUdLMYXwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f538.png
// module id = 1131
// module chunks = 0